import { Notifier, type INotice } from '@airbrake/browser';

export default {
  notify,
};

function notify(notice: INotice | Error): void {
  buildNotifier()?.notify(notice);
}

let _notifier: Notifier | undefined;
function buildNotifier() {
  if (!_notifier) {
    const { environment, projectId, projectKey } = window['airbrakeConfig'] || {};

    if (projectId && projectKey && environment !== 'development') {
      _notifier = new Notifier({ environment, projectId, projectKey });
    }
  }

  return _notifier;
}
